import React, { useState, useEffect } from 'react';
import Navbar from '../layout/Navbar';
import { Link } from 'react-router-dom';
import Footer from '../layout/Footer';
import P1 from '../assets/P1.png';
import P2 from '../assets/P2.jpg';
import P3 from '../assets/P3.jpg';
import P4 from '../assets/P4.jpg';
import { Phone, MessageCircle } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';


const products = [
    {
        id: 'intermediate-products',
        title: 'Intermediate Products',
        image: P1,
        description: 'PE-coated paper reels used for industrial packaging and disposables.',
        link: '/intermediate-products'
    },
    {
        id: 'paper-cup-fans',
        title: 'Paper Cup Fans',
        image: P2,
        description: 'Premium raw paper materials in plain or multicolor options.',
        link: '/paper-cup-fans'
    },
    {
        id: 'paper-cup',
        title: 'Paper Cups',
        image: P3,
        description: 'Tea cups in various sizes for offices, vendors, and events.',
        link: '/paper-cup'
    },
    {
        id: 'disposal-container',
        title: 'Disposal Container',
        image: P4,
        description: 'Custom branded containers and cups for your business identity.',
        link: '/disposal-container'
    }
];

const Product = ({ showFooter = true }) => {
    const [showScrollTop, setShowScrollTop] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('opacity-100', 'translate-y-0');
                        entry.target.classList.remove('opacity-0', 'translate-y-5');
                    }
                });
            },
            { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
        );

        document.querySelectorAll('.product-card').forEach((el) => {
            el.classList.add(
                'opacity-0',
                'translate-y-5',
                'transition-all',
                'duration-700',
                'ease-in-out'
            );
            observer.observe(el);
        });

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <Navbar />
            <section id="products" className="bg-gray-100 py-20">
                <div className="container mx-auto px-5">
                    <h2 className="text-center text-4xl mb-16 text-[#2c5530] font-bold relative after:content-[''] after:absolute after:bottom-[-10px] after:left-1/2 after:-translate-x-1/2 after:w-24 after:h-1 after:bg-gradient-to-r after:from-[#ff6b6b] after:to-[#ffa500] after:rounded">
                        Our Tea Cup Range
                    </h2>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
                        {products.map(({ id, title, image, description, link }) => (
                            <Link key={id} to={link}>
                                <div className="product-card bg-white rounded-2xl overflow-hidden shadow-lg hover:-translate-y-2 hover:shadow-2xl transition-all cursor-pointer">
                                    <div className="h-48 bg-white flex items-center justify-center text-6xl text-white">
                                        <img
                                            src={image}
                                            alt={title}
                                            className="w-full h-full object-cover"
                                        />
                                    </div>
                                    <div className="p-6 text-center">
                                        <h3 className="text-xl text-[#2c5530] mb-2 font-semibold">{title}</h3>
                                        <p className="text-sm text-gray-600 line-clamp-2">{description}</p>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>
            {showFooter && <Footer />}

            <div className="fixed bottom-5 right-5 flex flex-col gap-3 z-20">
                <a
                    href="tel:+919426788499"
                    className={`bg-sky-500 text-white w-12 h-12 rounded-lg text-xl flex items-center justify-center cursor-pointer hover:bg-sky-700 transition-all`}
                    title="Call Us"
                >
                    <Phone />
                </a>
                <a
                    href="https://wa.me/+919426788499"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`bg-[#3ed145] text-white w-12 h-12 rounded-lg text-xl flex items-center justify-center cursor-pointer hover:bg-[#2f8734] transition-all`}
                    title="Message on WhatsApp"
                >
                    <FaWhatsapp className='h-12 w-8' />
                </a>
            </div>
        </>
    );
};

export default Product;
